import Slides from './Slides.js';

import img1 from './images/portfolio/weddings-and-engagements/2/019.jpg';
import img2 from './images/portfolio/weddings-and-engagements/2/020.jpg';
import img3 from './images/portfolio/weddings-and-engagements/2/023.jpg';
import img4 from './images/portfolio/weddings-and-engagements/2/024.jpg';
import img5 from './images/portfolio/weddings-and-engagements/2/025.jpg';
import img6 from './images/portfolio/weddings-and-engagements/2/026.jpg';
import img7 from './images/portfolio/weddings-and-engagements/2/027.jpg';
import img8 from './images/portfolio/weddings-and-engagements/2/028.jpg';
import img9 from './images/portfolio/weddings-and-engagements/2/028z.jpg';
import img10 from './images/portfolio/weddings-and-engagements/2/029.jpg';
import img11 from './images/portfolio/weddings-and-engagements/2/030.jpg';
import img12 from './images/portfolio/weddings-and-engagements/2/0318_DSC7601.jpg';
import img13 from './images/portfolio/weddings-and-engagements/2/0396_IMG4200.jpg';
import img14 from './images/portfolio/weddings-and-engagements/2/042.jpg';
import img15 from './images/portfolio/weddings-and-engagements/2/0444_DSC6914.jpg';
import img16 from './images/portfolio/weddings-and-engagements/2/0463.jpg';
import img17 from './images/portfolio/weddings-and-engagements/2/0463_IMG5546.jpg';
import img18 from './images/portfolio/weddings-and-engagements/2/0487_IMG8141.jpg';
import img19 from './images/portfolio/weddings-and-engagements/2/052.jpg';
import img20 from './images/portfolio/weddings-and-engagements/2/057.jpg';
import img21 from './images/portfolio/weddings-and-engagements/2/0574.jpg';
import img22 from './images/portfolio/weddings-and-engagements/2/0592_DSC0870.jpg';

const images = [ 
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
    img18,
    img19,
    img20,
    img21,
    img22,
];

function Architectural() {
    return <Slides images={images}/>;
}

export default Architectural;
